import { Reporter } from '../reporter/Reporter'

type props = { text?: string }

export const BlackoutCurtains: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Blackout curtains'}
      link="https://www.amazon.com/Lemomo-Blackout-Curtains-Insulated-Darkening/dp/B07FVMNNQ3" // https://amzn.to/2JdMyZR
    />
  </div>
)

export const Melatonin: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Melatonin'}
      link="https://www.amazon.com/Sundown-Naturals-Melatonin-300-Tablets/dp/B000GG2I9O" // https://amzn.to/33jkbAD
    />
  </div>
)

export const LightTherapyLamp: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Light therapy lamp'}
      link="https://www.amazon.com/Ultra-Thin-Adjustable-Brightness-Temperature-Rotatable/dp/B08M917RHB"
    />
  </div>
)
